import {Api} from "./Api";
import { apiUrl } from "../enviroments/enviroments.dev";
import { CreateUserDto } from "../models/User";

const target = "/suppliers";

export class supplierService {

    public static getAllSuppliers(orgId:number) : Promise<Array<any>>{
        return Api.get(apiUrl(target+"/organization/"+orgId));
    }

    public static addSupplier( payload: CreateUserDto): Promise<any>{
        return Api.post(apiUrl(target+"/add/organization/"+payload.organizationId), payload);
    }
}
